import { Component, Input } from '@angular/core';

import { BehaviorScreen } from '../../core/models/view-models/monitor-models/screen.type';
import { ScreenContentStatus } from '../../core/enums/screen-status.enum';
import { ScreensStateService } from '../../core/services/screen-state/screens-state.service';

@Component({
  selector: 'screen-assign',
  templateUrl: './item-screen-assign.component.html',
  styleUrls: ['./item-screen-assign.component.scss']
})

export class ScreenAssignComponent {
  @Input() public screen: BehaviorScreen;
  screenStatuses = ScreenContentStatus;

  constructor(public selectionService: ScreensStateService) { }

  unselect() {
    this.selectionService.unselectScreen(this.screen, true);
  }
}
